/* Concierge B et B : villes du pied de page repliées par région.

   Le bloc est saisi en HTML libre dans l'admin, sous la forme d'un
   paragraphe portant le nom de la région, suivi d'une liste de villes.
   Ce script transforme chaque paire en bloc dépliable, sans toucher au
   contenu stocké : si le JavaScript ne se charge pas, la liste complète
   s'affiche exactement comme avant.

   Le nom de la région reste un lien vers sa page. Cliquer dessus navigue,
   cliquer ailleurs sur la ligne ouvre ou ferme la liste.
*/
(function () {
  'use strict';

  var MINIMUM_REGIONS = 2; // en dessous, replier n'apporte rien

  function replier(zone) {
    var paires = [];
    Array.prototype.forEach.call(zone.querySelectorAll('p'), function (titre) {
      var suite = titre.nextElementSibling;
      if (suite && suite.tagName === 'UL' && suite.children.length) {
        paires.push([titre, suite]);
      }
    });
    if (paires.length < MINIMUM_REGIONS) return;

    paires.forEach(function (paire) {
      var titre = paire[0];
      var liste = paire[1];

      var bloc = document.createElement('details');
      bloc.className = 'cbb-region';

      var ligne = document.createElement('summary');
      ligne.className = 'cbb-region__titre';

      var texte = document.createElement('span');
      texte.className = 'cbb-region__nom';
      while (titre.firstChild) texte.appendChild(titre.firstChild);

      var compteur = document.createElement('span');
      compteur.className = 'cbb-region__nombre';
      compteur.textContent = liste.children.length;

      var fleche = document.createElement('span');
      fleche.className = 'cbb-region__fleche';
      fleche.setAttribute('aria-hidden', 'true');

      ligne.appendChild(texte);
      ligne.appendChild(compteur);
      ligne.appendChild(fleche);

      titre.parentNode.insertBefore(bloc, titre);
      bloc.appendChild(ligne);
      bloc.appendChild(liste);
      liste.classList.add('cbb-region__villes');
      titre.parentNode.removeChild(titre);
    });

    zone.classList.add('cbb-regions');
  }

  function demarrer() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.footer-block__details-content'),
      replier
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
